import Script from 'next/script';
import '@/styles/global.css';
import '../../public/countdownTimer.css';
import { RouterProvider, Toast } from '@heroui/react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { AppProps } from 'next/app';
import { NextPageContext } from 'next';
import { useRouter } from 'next/router';
import Layout from '@components/main/layout';
import { useAmplitudePageTracking } from '@/hooks/useAmplitudePageTracking';
import CombinedProvider from '@context/combinedProvider';

export function MyApp({ Component, pageProps, initialContext }: AppProps & { initialContext: string }) {
	const ZOHO_WIDGET_CODE = process.env.NEXT_PUBLIC_ZOHO_WIDGET_CODE;
	const router = useRouter();

	useAmplitudePageTracking();

	return (
		<>
			<RouterProvider navigate={(href) => router.push(href)}>
				<NextThemesProvider defaultTheme='light'>
					<Toast.Provider />
					<CombinedProvider initialContext={initialContext}>
						<Layout>
							<Component {...pageProps} />
						</Layout>
					</CombinedProvider>
				</NextThemesProvider>
			</RouterProvider>
			<Script
				id='zoho-salesiq-script'
				strategy='afterInteractive'
				// biome-ignore lint/security/noDangerouslySetInnerHtml: Zoho bootstrap requires an inline initialization snippet.
				dangerouslySetInnerHTML={{
					__html: `
                    var $zoho = $zoho || {};$zoho.salesiq = $zoho.salesiq || {
                      widgetcode: "${ZOHO_WIDGET_CODE}",
                      values: {},
                      ready: function() {}
                    };
                    var d = document;
                    var s = d.createElement("script");
                    s.type = "text/javascript";
                    s.id = "zsiqscript";
                    s.defer = true;
                    s.src = "https://salesiq.zohopublic.eu/widget";
                    var t = d.getElementsByTagName("script")[0];
                    t.parentNode.insertBefore(s, t);
                  `,
				}}
			/>
		</>
	);
}

MyApp.getInitialProps = async ({ ctx }: { ctx: NextPageContext }) => {
	const { query } = ctx;
	const instance = query.instance ?? '';

	return { initialContext: instance };
};

export default MyApp;
